import { Languages } from '../knowledge-base-common/knowledge-base-common.type';

export const languages = [Languages.RU, Languages.KK, Languages.EN];

export const langLabels = {
    [Languages.RU]: 'На русском',
    [Languages.KK]: 'Қазақша',
    [Languages.EN]: 'In English',
};

export const ARTICLE_SIZE_LIMIT = 2_000;
export const RESULTS_COUNT_LIMIT = 10;
export const ASSISTANT_REPLY_DELAY = 500;

export const PHONE_LENGTH = 11;
export const MESSAGE_LENGTH = 700;
// export const EMAIL_LENGTH = 30;

export const AI_ASSISTANT_ALLOWED_FILE_EXTENSIONS = [
    'txt',
    'csv',
    'xls',
    'xlsx',
    'doc',
    'docx',
    'pdf',
    'json',
    'xml',
];

export const AI_ASSISTANT_ALLOWED_FILE_MIME_TYPES = [
    'text/plain',
    'text/csv',
    'application/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'application/json',
    'application/xml',
    'text/xml',
];

export const AI_ASSISTANT_FALLBACK_FILE_MIME_TYPES = [
    'application/octet-stream',
];

export const AI_ASSISTANT_UPLOAD_FILE_MIME_TYPES = [
    ...AI_ASSISTANT_ALLOWED_FILE_MIME_TYPES,
    ...AI_ASSISTANT_FALLBACK_FILE_MIME_TYPES,
];

const AI_ASSISTANT_ACCEPTED_FILE_EXTENSIONS = AI_ASSISTANT_ALLOWED_FILE_EXTENSIONS.map(
    (extension) => `.${extension}`
);

export const AI_ASSISTANT_ACCEPTED_FILE_TYPES = [
    ...AI_ASSISTANT_ACCEPTED_FILE_EXTENSIONS,
    ...AI_ASSISTANT_ALLOWED_FILE_MIME_TYPES,
].join(',');

export const AI_ASSISTANT_MAX_FILE_SIZE_MB = 50;
export const AI_ASSISTANT_MAX_FILE_SIZE_BYTES = AI_ASSISTANT_MAX_FILE_SIZE_MB * 1024 * 1024;
